import { setPump, setFertigation, reasonMessage } from '../mockStore.js';
import { t } from '../i18n.js';

export function renderWater(root, state, { canControl }) {
  const lang = state.lang;
  const w = state.water;
  const f = w.fertigation;
  const low = w.tankLevelPct < w.lowLevelThreshold;
  const typhoon = state.mode === 'typhoon';

  root.innerHTML = `
    <div class="view">
      <h2 class="view-title">${t(lang, 'water')}</h2>
      <div class="grid grid-2">
        <div class="card">
          <h3>缸水位</h3>
          <div class="stat-value big">${w.tankLevelPct}%</div>
          <div class="meta">低水位閾值 ${w.lowLevelThreshold}% — 低於閾值禁泵</div>
          <div style="height:12px;background:#eee;border-radius:3px;margin-top:8px;overflow:hidden">
            <div style="height:100%;width:${w.tankLevelPct}%;background:${low ? 'var(--danger)' : 'var(--blue)'}"></div>
          </div>
          ${low ? `<div class="lock-reason">低水位：灌溉泵／肥泵已禁（硬件亦會禁）</div>` : ''}
        </div>
        <div class="card controls-only">
          <h3>灌溉／街水／肥泵</h3>
          <div class="toggle-row">
            <div><span class="label">${w.irrigationPump.name}</span></div>
            <button type="button" class="btn sm ${w.irrigationPump.on ? 'primary' : ''}" data-pump="irrigation" ${low || typhoon ? 'disabled' : ''}>${w.irrigationPump.on ? 'ON' : 'OFF'}</button>
          </div>
          <div class="toggle-row">
            <div><span class="label">${w.streetValve.name}</span></div>
            <button type="button" class="btn sm ${w.streetValve.on ? 'primary' : ''}" data-pump="street" ${typhoon ? 'disabled' : ''}>${w.streetValve.on ? 'ON' : 'OFF'}</button>
          </div>
          <div class="toggle-row">
            <div><span class="label">${w.fertPump.name}</span></div>
            <button type="button" class="btn sm ${w.fertPump.on ? 'primary' : ''}" data-pump="fert" ${low || typhoon ? 'disabled' : ''}>${w.fertPump.on ? 'ON' : 'OFF'}</button>
          </div>
        </div>
        <div class="card controls-only">
          <h3>肥水 EC／微生物循環</h3>
          <div class="stat-row"><span class="stat-label">EC 目標</span><span class="stat-value">${f.ecTarget.toFixed(1)} mS/cm（上限 ${f.ecMax}）</span></div>
          <div class="slider-row">
            <input type="range" min="0.5" max="${f.ecMax}" step="0.1" value="${f.ecTarget}" data-ec ${typhoon ? 'disabled' : ''} />
            <span class="pct">${f.ecTarget.toFixed(1)}</span>
          </div>
          <div class="toggle-row">
            <div>
              <span class="label">微生物循環</span>
              <span class="hint">已跑 ${f.microbialHoursRun.toFixed(2)} h / 上限 ${f.microbialMaxHours} h</span>
            </div>
            <button type="button" class="btn sm ${f.microbialCycleOn ? 'primary' : ''}" data-micro ${typhoon ? 'disabled' : ''}>
              ${f.microbialCycleOn ? 'ON' : 'OFF'}
            </button>
          </div>
        </div>
        <div class="card">
          <h3>說明</h3>
          <div class="meta">EC／微生物為 mock 參數檔邏輯；EC/pH 閉環硬件座預留，v0 唔做閉環控制。</div>
        </div>
      </div>
      <div id="wat-toast" class="lock-reason" style="display:none;margin-top:10px"></div>
    </div>
  `;

  const toast = root.querySelector('#wat-toast');
  function show(r) {
    if (!r) return;
    if (r.ok) { toast.style.display = 'none'; return; }
    toast.style.display = 'block';
    toast.textContent = reasonMessage(r.reason, lang);
  }

  root.querySelectorAll('[data-pump]').forEach((el) => {
    el.addEventListener('click', () => {
      const which = el.dataset.pump;
      const map = { irrigation: w.irrigationPump.on, fert: w.fertPump.on, street: w.streetValve.on };
      show(setPump(which, !map[which]));
    });
  });
  const ec = root.querySelector('[data-ec]');
  if (ec) ec.addEventListener('change', () => show(setFertigation({ ecTarget: Number(ec.value) })));
  const micro = root.querySelector('[data-micro]');
  if (micro) micro.addEventListener('click', () => show(setFertigation({ microbialCycleOn: !f.microbialCycleOn })));
}
